var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 82.54 110.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#343838;}.cls-2{opacity:0.7;fill:url(#linear-gradient);}.cls-3{opacity:0.6;fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 41.27,
    y1: 108.5,
    x2: 41.27,
    y2: 82.7,
    gradientUnits: "userSpaceOnUse",
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343838",
    stopOpacity: 0,
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#343838",
    stopOpacity: 0.07,
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#343838",
    stopOpacity: 0.3,
    fill: "#343838"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 71.82,
    y1: 12.27,
    x2: 62.76,
    y2: 20.46,
    gradientUnits: "userSpaceOnUse",
    fill: "#343838"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00DFFC",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFFC",
    stopOpacity: 0,
    fill: "#343838"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "About Us0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M41.27,0a41.27,41.27,0,0,0-28.8,70.82L4.37,82.54h36.9A41.27,41.27,0,0,0,41.27,0Zm11,68.55q-3.83,1.51-6.12,2.3a16.14,16.14,0,0,1-5.31.79q-4.64,0-7.22-2.27A7.31,7.31,0,0,1,31,63.64a20.88,20.88,0,0,1,.19-2.77c.13-.94.34-2,.62-3.19L35,46.38c.28-1.08.53-2.11.72-3.07A13.63,13.63,0,0,0,36,40.64a4.1,4.1,0,0,0-.89-3c-.6-.57-1.73-.85-3.42-.85a9,9,0,0,0-2.54.38c-.86.26-1.61.5-2.22.74l.85-3.48q3.14-1.28,6-2.19a17.76,17.76,0,0,1,5.42-.92c3.07,0,5.45.75,7.11,2.23a7.4,7.4,0,0,1,2.5,5.79q0,.74-.17,2.59A17.36,17.36,0,0,1,48,45.33L44.86,56.6c-.26.9-.49,1.94-.7,3.09a16.36,16.36,0,0,0-.31,2.63,3.78,3.78,0,0,0,1,3.06,5.63,5.63,0,0,0,3.48.82A10.09,10.09,0,0,0,51,65.79a15,15,0,0,0,2.13-.71Zm-.56-45.74a7.6,7.6,0,0,1-5.36,2.07,7.68,7.68,0,0,1-5.38-2.07,6.6,6.6,0,0,1-2.24-5,6.67,6.67,0,0,1,2.24-5,7.62,7.62,0,0,1,5.38-2.09,7.54,7.54,0,0,1,5.36,2.09,6.77,6.77,0,0,1,0,10Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2.21,110.49h30.5l-.87-3.09c-.28-1.19-.49-2.25-.62-3.19a20.89,20.89,0,0,1-.19-2.77,7.31,7.31,0,0,1,2.57-5.75q2.57-2.26,7.22-2.27a16.14,16.14,0,0,1,5.31.79q2.29.79,6.12,2.3l.85,3.48A15,15,0,0,0,51,99.29a10.09,10.09,0,0,0-2.63-.41,5.63,5.63,0,0,0-3.48.82,3.78,3.78,0,0,0-1,3.06,16.37,16.37,0,0,0,.31,2.63c.21,1.16.44,2.19.7,3.09l.57,2h34.9a41.28,41.28,0,0,0-39.06-28H4.37l8.1,11.72A41.29,41.29,0,0,0,2.21,110.49Z",
    fill: "#343838"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.27,1S58.5.17,71.41,15.25a40.42,40.42,0,0,1,10.11,28Z",
    fill: "#343838"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsNew);
export default __webpack_public_path__ + "static/media/AboutUS-new.f759e87ae64fecb4df6e47ed0c9a924e.svg";
export { ForwardRef as ReactComponent };